import React, { FC } from "react"
import { DefaultMoodIconSize } from "../../utils/constants"
import { MoodIconProps } from "../../utils/types"

const EnjoymentIcon: FC<MoodIconProps> = ({
  x,
  y,
  backgroundColor,
  height = DefaultMoodIconSize,
  width = DefaultMoodIconSize,
}) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 22 22"
      fill="none"
      x={x}
      y={y}
    >
      <rect
        width={height}
        height={width}
        fill={!backgroundColor ? "white" : backgroundColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.585 2.75859L10.9981 3.36184L10.4119 2.75837C9.02511 1.32873 7.05893 0.67433 5.1263 0.997619C3.19199 1.32119 1.52436 2.58521 0.645219 4.39752L0.539781 4.62657C-0.471254 6.96035 -0.0349717 9.66197 1.62189 11.5107L10.1933 20.7276C10.6342 21.2017 11.363 21.2017 11.8038 20.7275L20.2233 11.672C22.0692 9.76872 22.5315 6.8298 21.3519 4.39761L21.2333 4.16575C20.3113 2.46354 18.7093 1.30517 16.8708 0.997619C14.9382 0.67433 12.972 1.32873 11.585 2.75859ZM16.5157 3.31307C17.6816 3.50809 18.6944 4.24047 19.2669 5.29709L19.3611 5.48129L19.4466 5.67019C20.0348 7.06737 19.7749 8.71527 18.7708 9.86699L10.9981 18.227L3.38515 10.041C2.24114 8.86204 1.92825 7.10952 2.57478 5.61669L2.65879 5.43433C3.20108 4.31704 4.25498 3.51821 5.48134 3.31307C6.70937 3.10765 7.95769 3.52312 8.83498 4.42753L10.2102 5.84451C10.6473 6.2949 11.3498 6.2949 11.7869 5.84451L13.1619 4.42775C14.0394 3.52312 15.2877 3.10765 16.5157 3.31307Z"
        fill="#FF776C"
      />
    </svg>
  )
}

export default EnjoymentIcon
